import { Outlet } from "react-router-dom";
import StationForm from "./StationForm";
import StationList from "./StationList";

export const adminStationsRoutes = [
  {
    path: "stations",
    element: Outlet,
    children: [
      {
        path: "",
        element: StationList,
      },
      {
        path: "list",
        element: StationList,
      },
      {
        path: "add",
        element: StationForm,
      },
      {
        path: "edit/:id",
        element: StationForm,
      },
    ],
  },
];
